const types = { // actions
  setActiveUser              : "usuario/setActive",
  setModuloActivo            : "modulo/setModuloActivo",
  setProspectoActivo         : "prospecto/setProspectoActivo",
  setNumNotificaciones       : "notificaciones/setNumNotificaciones",
  setNotificaciones          : "notificaciones/setNotificaciones",
  setNotificacionesNuevas    : "notificaciones/setNotificacionesNuevas",
  setNotificacionesAnteriores: "notificaciones/setNotificacionesAnteriores"
}

const initialStore = { // State
  usuarioActivo           : {},
  moduloActivo            : "contactos",
  prospectoActivo         : {},
  numNotificaciones       : 0,
  notificaciones          : [],
  notificacionesNuevas    : [],
  notificacionesAnteriores: []
}

const storeReducer = (state, action) => { //mutations
  switch (action.type) {
    case types.setActiveUser:
      return {
        ...state,
        usuarioActivo: action.payload
      }
      break

    case types.setModuloActivo:
      return {
        ...state,
        moduloActivo: action.payload
      }
      break

    case types.setProspectoActivo:
      return {
        ...state,
        prospectoActivo: action.payload
      }
      break

    case types.setNumNotificaciones:
      return {
        ...state,
        numNotificaciones: action.payload
      }
      break

    case types.setNotificacionesNuevas:
      return {
        ...state,
        notificacionesNuevas: action.payload
      }
      break

    case types.setNotificacionesAnteriores:
      return {
        ...state,
        notificacionesAnteriores: action.payload
      }
      break

    case types.setNotificaciones:
      return {
        ...state,
        notificaciones: action.payload
      }
      break

    default:
      return state
  }
}

export { initialStore, types }
export default storeReducer
